import { cn } from '@/utils/cn';

export function Spinner({ className, label = 'Carregando' }) {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-label={label}
      className={cn(
        'inline-block h-5 w-5 animate-spin rounded-full border-2 border-[var(--border)] border-t-[var(--primary)]',
        className,
      )}
    />
  );
}
